import React from 'react'
import { motion } from 'framer-motion'
import { MapPin, Sun, Cloud, CloudRain, CloudSnow, Wind, Eye, Droplets } from 'lucide-react'

const WeatherWidget = ({ weather, location }) => {
  if (!weather || !location) {
    return (
      <motion.div 
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className="inline-flex items-center space-x-2 px-4 py-2 bg-gray-100 rounded-full text-sm text-gray-500"
      >
        <MapPin className="w-4 h-4" />
        <span>获取位置信息中...</span>
      </motion.div>
    )
  }

  const getWeatherIcon = (condition) => {
    const iconProps = { className: "w-5 h-5" }
    
    switch (condition?.toLowerCase()) {
      case 'clear':
      case 'sunny':
        return <Sun {...iconProps} className="w-5 h-5 text-yellow-500" />
      case 'clouds':
      case 'cloudy':
        return <Cloud {...iconProps} className="w-5 h-5 text-gray-500" />
      case 'rain':
      case 'drizzle':
        return <CloudRain {...iconProps} className="w-5 h-5 text-blue-500" />
      case 'snow':
        return <CloudSnow {...iconProps} className="w-5 h-5 text-blue-300" />
      default:
        return <Sun {...iconProps} className="w-5 h-5 text-yellow-500" />
    }
  }

  const getWeatherEmoji = (condition) => {
    switch (condition?.toLowerCase()) {
      case 'clear':
      case 'sunny':
        return '☀️'
      case 'clouds':
      case 'cloudy':
        return '☁️'
      case 'rain':
      case 'drizzle':
        return '🌧️'
      case 'snow':
        return '❄️'
      default:
        return '☀️'
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="inline-flex items-center space-x-3 px-6 py-3 bg-white bg-opacity-80 backdrop-blur-sm rounded-full shadow-lg border border-white border-opacity-20"
    >
      {/* 位置信息 */}
      <div className="flex items-center space-x-2">
        <MapPin className="w-4 h-4 text-gray-600" />
        <span className="text-sm font-medium text-gray-700">
          {location.city || location.name || '未知地点'}
        </span>
      </div>

      {/* 分隔符 */}
      <div className="w-px h-4 bg-gray-300"></div>

      {/* 天气信息 */}
      <div className="flex items-center space-x-2">
        <span className="text-lg">{getWeatherEmoji(weather.condition)}</span>
        <span className="text-sm text-gray-600 capitalize">
          {weather.description || weather.condition}
        </span>
      </div>

      {/* 分隔符 */}
      <div className="w-px h-4 bg-gray-300"></div>

      {/* 温度 */}
      <div className="flex items-center space-x-1">
        <span className="text-lg font-semibold text-gray-800">
          {Math.round(weather.temperature)}°C
        </span>
      </div>

      {/* 额外信息（可选显示） */}
      {weather.humidity && (
        <>
          <div className="w-px h-4 bg-gray-300"></div>
          <div className="flex items-center space-x-1">
            <Droplets className="w-3 h-3 text-blue-500" />
            <span className="text-xs text-gray-600">
              {weather.humidity}%
            </span>
          </div>
        </>
      )}
    </motion.div>
  )
}

export default WeatherWidget
